// legacyDuoDark theme was added in order to use the original colors for the duo sub landing page as flipping them looked strange in this case
export type Theme =
  | 'duoLight'
  | 'duoDark'
  | 'familyLight'
  | 'familyDark'
  | 'duoLegacyDark';
export type ThemeSet = {
  light: Theme;
  dark: Theme;
  legacyDark?: Theme;
};

export const PLAN_DUO_THEMES: ThemeSet = {
  light: 'duoLight',
  dark: 'duoDark',
  legacyDark: 'duoLegacyDark',
};
export const PLAN_FAMILY_THEMES: ThemeSet = {
  light: 'familyLight',
  dark: 'familyDark',
};

const defaultTheme = PLAN_DUO_THEMES.light;
export type Themed = { [key in Theme]: any };

export default function theme(config: Themed) {
  return (props: { theme?: { mode?: Theme } }) => {
    const themeMode = props?.theme?.mode || defaultTheme;

    return config[themeMode];
  };
}
